import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { DettaglioTavola, Immagine } from "../../types"
import DettaglioTavolaForm from "./DettaglioTavolaForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesDettaglioTavola, validationSchemaDettaglioTavola } from "./DettaglioTavolaCommon"

export default function DettaglioTavolaModal({
  title,
  dettaglioTavola,
  save,
  show,
  onClose,
  immagine,
}: {
  title: string
  dettaglioTavola?: DettaglioTavola
  save: (values: DettaglioTavola) => Promise<void>
  show: boolean
  onClose: () => void
  immagine?: Immagine
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesDettaglioTavola(dettaglioTavola) as DettaglioTavola}
      validationSchema={validationSchemaDettaglioTavola()}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>
                <ModalTitle>{title}</ModalTitle>
              </ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <DettaglioTavolaForm immagine={immagine} col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
